import Flex from "../../../../designComponents/Flex";
import Typography from "../../../../designComponents/Typography";

type Props = {
  rules: {
    icon: string;
    category: string;
    rule: string;
    description: string;
  }[];
};

const RulesViewer = ({ rules }: Props) => {
  return (
    <Flex>
      {rules?.map((r) => {
        return (
          <Flex direction="column" gap="10px">
            <Flex direction="row" gap="16px">
              <img
                src={r.icon}
                alt={r.category}
                style={{ height: "24px", width: "24px" }}
              />
              <Typography>{r.category}</Typography>
            </Flex>
            <Typography color="dark.black" size="title">
              {r.rule}
            </Typography>
            <Typography>{r.description}</Typography>
          </Flex>
        );
      })}
    </Flex>
  );
};

export default RulesViewer;
